module.exports = __webpack_public_path__ + "img/aruba.e32fc4b2.svg";